import { useMemo } from "react";
import { useSmartrrVendorSelector } from "@vendor-app/app/_state/typedVendorReduxHooks";
import { AccountPlanStatusEnum } from "@smartrr/shared/entities/AccountPlan";

export const useHasTrialExpired = () => {
  const { activePlan } = useSmartrrVendorSelector(state => state.accountPlans);
  const isSuperUser = useSmartrrVendorSelector(state => state.auth.user?.isSuperUser);
  const noActivePlan = !activePlan || activePlan.status === AccountPlanStatusEnum.EXPIRED_TRIAL;

  return useMemo(() => noActivePlan && !isSuperUser, [activePlan, isSuperUser]);
};
